import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
    FiSettings,
    FiFileText,
    FiShield,
    FiLogOut,
    FiCreditCard,
} from "react-icons/fi";
import { useAuth } from "../../contexts/AuthContext";
import { FOOTER_LEGAL_URLS } from "../../components/Footer";

const AccountSidebar = () => {
    const { signOut } = useAuth();
    const location = useLocation();

    const isEmployerArea = location.pathname.includes("/employer");

    const settingsPath = isEmployerArea
        ? "/employer/account-settings"
        : "/employee/account-settings";

    const paymentPath = isEmployerArea
        ? "/employer/payment-history"
        : "/employee/payment-history";

    const isAccountActive =
        location.pathname === "/profile" ||
        location.pathname === settingsPath;

    const isPaymentActive =
        location.pathname === paymentPath ||
        location.pathname.endsWith("/payment-history");

    const handleLogout = async () => {
        try {
            await signOut();
        } catch (e) {
            console.error("Logout error:", e);
        }
    };

    return (
        <aside className="w-full md:w-72 flex-shrink-0 mb-8 md:mb-0">
            <div className="bg-white rounded-2xl border border-gray-200 p-6 flex flex-col gap-2">
                <h2 className="text-lg font-semibold mb-4 text-gray-900">
                    Manage your account
                </h2>

                <nav className="flex flex-col gap-2 mb-6">
                    <Link
                        to={settingsPath}
                        className={`flex items-center gap-2 px-3 py-2 rounded-lg font-medium transition-colors text-sm ${
                            isAccountActive
                                ? "bg-gray-100 text-gray-900"
                                : "hover:bg-gray-50 text-gray-700"
                        }`}
                    >
                        <FiSettings className="flex-shrink-0" />
                        Account settings
                    </Link>

                    <Link
                        to={paymentPath}
                        className={`flex items-center gap-2 px-3 py-2 rounded-lg font-medium transition-colors text-sm ${
                            isPaymentActive
                                ? "bg-gray-100 text-gray-900"
                                : "hover:bg-gray-50 text-gray-700"
                        }`}
                    >
                        <FiCreditCard className="flex-shrink-0" />
                        Payment history
                    </Link>

                    <a
                        href={FOOTER_LEGAL_URLS.termsOfService}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-2 px-3 py-2 rounded-lg font-medium transition-colors hover:bg-gray-50 text-gray-700 text-sm"
                    >
                        <FiFileText className="flex-shrink-0" />
                        Terms of Service
                    </a>
                    <a
                        href={FOOTER_LEGAL_URLS.privacyPolicy}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-2 px-3 py-2 rounded-lg font-medium transition-colors hover:bg-gray-50 text-gray-700 text-sm"
                    >
                        <FiShield className="flex-shrink-0" />
                        Privacy Policy
                    </a>
                </nav>

                <button
                    type="button"
                    onClick={handleLogout}
                    className="w-full bg-black text-white py-2 rounded-full font-semibold flex items-center justify-center gap-2 mt-2 hover:bg-gray-800 transition-colors text-sm"
                >
                    <FiLogOut />
                    Log out
                </button>
            </div>
        </aside>
    );
};

export default AccountSidebar;
